(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairImportVisitorsController', VirtualFairImportVisitorsController)

    VirtualFairImportVisitorsController.$inject = ['$uibModal', 'ExpoService', 'VirtualFairService', 'AclService'];


    function VirtualFairImportVisitorsController($uibModal, ExpoService, VirtualFairService, AclService) {
        var vm = this;

        vm.exhibitors            = '';
        vm.queryFlag             = false;
        vm.expos                 = '';
        vm.expoSelected          = '';
        vm.selectExpo            = selectExpo;
        vm.getByFilter           = getByFilter;
        vm.openUploadModal       = openUploadModal;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems   = 0;
        vm.currentPage  = 0;
        vm.itemsPerPage = 0;
        vm.page         = 1;


        activate();


        function setPage(page) {
            vm.currentPage = page;
        };


        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        };


        function activate() {
            vm.selectExpo();
        }

        function selectExpo() {
            var today = new Date(),
                today = today.getUTCFullYear() + '-' + (today.getUTCMonth()+1) + '-' + today.getUTCDate();

            vm.query = {};
            vm.query['search'] = 'id:15;expo_date:'+today;
            vm.query['searchFields'] = 'id:>=;expo_date:>=';
            vm.query['searchJoin'] = 'and';
            vm.query['orderBy'] = 'expo_date';
            vm.query['sortedBy'] = 'desc';

            VirtualFairService.all(vm.query).then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function openUploadModal() {

            $uibModal.open({
                templateUrl: 'templates/virtualfairs/general-visitors/upload/upload.modal.html',
                controller: 'VirtualFairImportVisitorsModalController',
                controllerAs:'vm',
                resolve:
                {
                    getByFilter: function() {
                        return vm.getByFilter;
                    },
                    virtualFair: function() {
                        return vm.expoSelected;
                    }
                }
            });
        }

        function getByFilter() {
            vm.query = {};
            vm.query['virtual_fair_id'] = vm.expoSelected.id;
            vm.query['page'] = vm.page;

            VirtualFairService.getGeneralVisitors(vm.query).then(function(response) {
                vm.visitors = response.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.queryFlag = true;
                vm.setPage(response.data.current_page);

            }).catch(function(err) {
            });
        }

    }

})();
